import ApiService from './service';
import * as http from './http';

export class FutureFlexService extends ApiService {

    async getAllFutureFlexEmployeeRecords(request) {
        const { resource, ...params } = request;
        const url = `${this.apiDomain}/${resource}`;
        try {
            const response = await http.get(url, this.store, { params });
            return { data: response.data };
        } catch (error) {
            console.error("❌ [GET] Error fetching Future Flex employee records:", error);
            return { data: [] };
        }
    }

    async getFutureFlexEmployeeRecordById(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.get(url, this.store);
            return { data: response.data };
        } catch (error) {
            console.error("❌ [GET] Error fetching Future Flex employee by ID:", error);
            return { data: null };
        }
    }

    async getFutureFlexEmployeeRecordByEmail(request) {
        const url = `${this.apiDomain}/${request.resource}?email=${encodeURIComponent(request.email)}`;
        try {
            const response = await http.get(url, this.store);
            return { data: response.data };
        } catch (error) {
            console.error("❌ [GET] Error fetching Future Flex employee by Email:", error);
            return { data: null };
        }
    }

    async postFutureFlexEmployeeRecord(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.post(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [POST] Error creating Future Flex employee record:", error);
            return null;
        }
    }

    async updateFutureFlexEmployeeRecord(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.put(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [PUT] Error updating Future Flex employee record:", error);
            return null;
        }
    }

    async updateFutureFlexStartDate(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.put(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [PUT] Error updating Future Flex employee start date:", error);
            return null;
        }
    }

    async updateFutureFlexPlans(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.put(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [PUT] Error updating Future Flex employee Plans:", error);
            return null;
        }
    }

    async updateFutureFlexRemarks(request, data) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.put(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [PUT] Error updating Future Flex employee Remarks:", error);
            return null;
        }
    }

    async deleteFutureFlexEmployeeRecord(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        try {
            const response = await http.remove(url, this.store);
            return response;
        } catch (error) {
            console.error("❌ [DELETE] Error deleting Future Flex employee record:", error);
            return null;
        }
    }

    async softDeleteFutureFlexEmployeeRecord(request) {
        const url = `${this.apiDomain}/${request.resource}`;
        const data = { isdeleted: true };
        try {
            const response = await http.patch(url, data, this.store);
            return response;
        } catch (error) {
            console.error("❌ [PATCH] Error soft deleting Future Flex employee record:", error);
            return null;
        }
    }


    async getFilterOptions() {
        const url = `${this.apiDomain}/api/futureflex`; 
        try {
            const response = await http.get(url, this.store);
            return { data: response.data };
        } catch (error) {
            console.error("❌ [GET] Error fetching filter options:", error);
            return { data: [] }; 
        }
    }
}
